import { mapActions, mapState } from 'vuex'
import store from '@/store'
import axios from 'axios'
import router from '@/router/'

export default {
  name: 'FiltroReportes',
  components: {
  },
  props: {
    filtroClienteEnable: null,
    filtroEstadoEnable: null,
    filtroCamionEnable: null,
    filtroConductorEnable: null,
    filtroRevisionEnable: null,
    filtroEstadoSiniestroEnable: null,
    filtroEstadoAndinaSupermercadoEnable: null,
    filtroEstadoAcarreoEnable: null,
    filtroPatenteEnable: null,
    filtroAdministradorFlotaEnable: null,
    filtroCentroCostoEnable: null,
    filtroCentroCostoByNameEnable: null,
    filtroFolioAcarreoEnable: null,
    filtroFieldAcarreoEnable: null,
    filtroFieldNameAcarreo: null,
    downloadButtonaEnable: null
  },
  data: function () {
    return {
      fechaDesde: '',
      fechaHasta: '',
      selectedCliente: null,
      optionsCliente: [
        { value: null, text: 'Cliente' }
        // { value: 'Andina', text: 'Andina' },
        // { value: 'Sopraval', text: 'Sopraval' },
        // { value: 'Soprole', text: 'Soprole' }
      ],
      selectedConductor: null,
      optionsConductor: [
        { value: null, text: 'Conductor' }
      ],
      selectedCamion: null,
      optionsCamion: [
        { value: null, text: 'Camion' }
      ],
      selectedPatente: null,
      optionsPatentes: [],
      selectedEstado: null,
      optionsEstado: [
        { value: null, text: 'Estado' },
        { value: 'entregada', text: 'Entregada' },
        { value: 'pendiente a salir', text: 'Pendiente a salir' },
        { value: 'en ruta', text: 'En Ruta' },
        { value: 'no realizado', text: 'No realizado' }
      ],
      selecteRevision: null,
      optionsRevision: [
        { value: null, text: 'Estado Revisión' },
        { value: 'R', text: 'Revisada' },
        { value: 'P', text: 'Por revisar' },
        { value: 'E', text: 'Eliminada' }
      ],
      selectedEstadoSiniestro: null,
      optionsEstadoSiniestro: [
        { value: null, text: 'Estado Siniestro' }
      ],
      selectedEstadoAndinaSupermercado: null,
      optionsEstadoAndinaSupermercado: [
        { value: null, text: 'Estado Andina Supermercado' }
      ],
      selectedEstadoAcarreo: null,
      optionsEstadoAcarreo: [
        { value: null, text: 'Estado Acarreo' }
      ],
      selectedAdministradorFlota: null,
      optionsAdministradorFlota: [
        { value: null, text: 'Administrador Flota' }
      ],
      selectedCentroCosto: null,
      optionsCentroCosto: [
        { value: null, text: 'Centro de costo' },
        { value: '101', text: 'BoF' },
        { value: '102', text: 'BoP' },
        { value: '103', text: 'Sopraval' },
        { value: '104', text: 'Andina Acarreo' },
        { value: '105', text: 'Veralia' },
        { value: '106', text: 'SPMK' },
        { value: '107', text: 'Acarreo' }
      ],
      folioAcarreo: '',
      fieldValueAcarreo: '',
      selectedCentroCostoByName: null,
      optionsCentroCostoByName: [
        { value: null, text: 'Centro de costo' },
        { value: 'BoF', text: 'BoF' },
        { value: 'BoP', text: 'BoP' },
        { value: 'Sopraval', text: 'Sopraval' },
        { value: 'Andina Acarreo', text: 'Andina Acarreo' },
        { value: 'Veralia', text: 'Veralia' },
        { value: 'SPMK', text: 'SPMK' },
        { value: 'Acarreo', text: 'Acarreo' }
      ]
    }
  },
  watch: {
  },
  mounted () {
    this.getConductores().then((res) => {
      for (const conductor in this.conductores) {
        this.optionsConductor.push({ value: this.conductores[conductor].device_alias, text: this.conductores[conductor].device_alias })
      }
      this.optionsConductor.sort((a, b) => a.text.localeCompare(b.text))
      // this.optionsConductor.sort((a, b) => a.text.localeCompare(b.text))
    })
    this.getCamiones().then((res) => {
      const camionesAux = this.camiones
      for (const camion in camionesAux) {
        const data = {}
        data.text = camionesAux[camion].cam_basis
        data.value = camionesAux[camion].cam_basis
        this.optionsCamion.push(data)
      }
      // this.optionsCamion.sort((a, b) => a.text.localeCompare(b.text))
      for (const camion in camionesAux) {
        const data = {}
        data.text = camionesAux[camion].matricula
        data.value = camionesAux[camion].matricula
        this.optionsPatentes.push(data)
      }
      this.optionsPatentes = [
        { value: null, text: 'Patente' },
        ...this.optionsPatentes
          .filter(opt => opt.value !== null)
          .sort((a, b) => a.text.localeCompare(b.text))
      ]
    })
    this.getClientes().then((res) => {
      this.clientes.forEach(element => {
        if (this.permisos.some(objeto => objeto.nombre === element.nombre)) {
          this.optionsCliente.push({
            value: element.nombre,
            text: element.nombre
          })
        }
      })
    })
    this.getEstadosSiniestros().then((res) => {
      console.log(this.estados)
      for (const e in this.estados) {
        this.optionsEstadoSiniestro.push({ value: this.estados[e], text: this.estados[e] })
      }
      console.log(this.optionsEstadoSiniestro)
    })
    this.getEstadosAndinaSupermercado().then((res) => {
      console.log(this.estadosAndinaSupermercado)
      for (const e in this.estadosAndinaSupermercado) {
        this.optionsEstadoAndinaSupermercado.push({ value: this.estadosAndinaSupermercado[e], text: this.estadosAndinaSupermercado[e] })
      }
      console.log(this.optionsEstadoAndinaSupermercado)
    })
    this.getEstadosAcarreo().then((res) => {
      console.log(this.estadosAcarreo)
      for (const e in this.estadosAcarreo) {
        this.optionsEstadoAcarreo.push({ value: this.estadosAcarreo[e], text: this.estadosAcarreo[e] })
      }
      console.log(this.optionsEstadoAcarreo)
    })
    this.getAdministradores().then((res) => {
      // console.log(this.administradores)
      this.administradores.forEach(element => this.optionsAdministradorFlota.push({
        value: element.nombre,
        text: element.nombre
      }))
    })
  },
  methods: {
    ...mapActions('Cliente', [
      'getClientes'
    ]),
    ...mapActions('Siniestros', [
      'getSiniestros', 'updateEstadoSiniestro', 'deleteSiniestro', 'getEstadosSiniestros'
    ]),
    ...mapActions('AndinaSupermercado', [
      'getEstadosAndinaSupermercado'
    ]),
    ...mapActions('Acarreo', [
      'getEstadosAcarreo'
    ]),
    ...mapActions('AdministradorFlota', [
      'getConductores', 'getCamiones'
    ]),
    ...mapActions('Administrador', [
      'getAdministradores'
    ]),
    test () {
      console.log('test')
    },
    Buscar (forDownload) {
      const fechaDesde = this.fechaDesde + ' 00:00:00'
      const fechaHasta = this.fechaHasta + ' 23:59:00'
      const periodo = {}
      periodo.fechaDesde = fechaDesde
      periodo.fechaHasta = fechaHasta
      if (this.selectedCliente != null) {
        periodo.cliente = this.selectedCliente
      }
      if (this.selectedCamion != null) {
        periodo.camion = this.selectedCamion
      }
      if (this.selectedConductor != null) {
        periodo.conductor = this.selectedConductor
      }
      if (this.selectedEstado != null) {
        periodo.estado = this.selectedEstado
      }
      if (this.selecteRevision != null) {
        periodo.revision = this.selecteRevision
      }
      if (this.selectedEstadoSiniestro != null) {
        periodo.estadoSiniestro = this.selectedEstadoSiniestro
      }
      if (this.selectedEstadoAndinaSupermercado != null) {
        periodo.estadoAndinaSupermercado = this.selectedEstadoAndinaSupermercado
      }
      if (this.selectedEstadoAcarreo != null) {
        periodo.estadoAcarreo = this.selectedEstadoAcarreo
      }
      if (this.selectedPatente != null) {
        periodo.patente = this.selectedPatente
      }
      if (this.selectedConductor != null) {
        periodo.conductor = this.selectedConductor
      }
      if (this.selectedAdministradorFlota != null) {
        periodo.administrador = this.selectedAdministradorFlota
      }
      if (this.selectedCentroCosto != null) {
        periodo.centroCosto = this.selectedCentroCosto
      }
      if (this.selectedCentroCostoByName != null) {
        periodo.centroCostoByName = this.selectedCentroCostoByName
      }
      if (this.folioAcarreo != null && this.folioAcarreo.trim() !== '') {
        periodo.folio = this.folioAcarreo.trim()
      }
      if (this.filtroFieldNameAcarreo && this.fieldValueAcarreo != null && this.fieldValueAcarreo.trim() !== '') {
        periodo.fieldName = this.filtroFieldNameAcarreo
        periodo.fieldValue = this.fieldValueAcarreo.trim()
      }
      periodo.forDownload = forDownload
      this.$emit('dataFiltroReporte', periodo)
      // console.log(periodo)
    },
    async getTransportes (periodo) {
      try {
        const response = await axios({
          method: 'post',
          url: `${store.state.host}/api/vps/vueltas/getTransportes`,
          data: {
            // fechaDesde: '2022-08-19T00:00:00.000+00:00',
            fechaDesde: periodo.fechaDesde,
            fechaHasta: periodo.fechaHasta
          },
          headers: {
            Authorization: 'Bearer ' + store.state.token
          }
        })
        if (response.status === 200) { // response - object, eg { status: 200, message: 'OK' }
          console.log('success stuff api transporte')
          console.log(response.data)
          return true
        } else {
          // commit('set_token', 'clave o usuario invalido')
          console.log('por else transporte')
        }
        return false
      } catch (err) {
        console.error(err)
        console.log('por catch transporte')
        router.push({ path: '/' })
        // dispatch('GetActividadesCoordinador')
        // this.dispatch.GetActividadesCoordinador()
        // commit('set_token', 'clave o usuario invalido')
        return false
      }
    }
  },
  computed: {
    ...mapState('AdministradorFlota', ['transportes']),
    ...mapState('AdministradorFlota', ['transportes2']),
    ...mapState('AdministradorFlota', ['camiones']),
    ...mapState('AdministradorFlota', ['conductores']),
    ...mapState('AdministradorFlota', ['transportesNoAsignados']),
    ...mapState('AdministradorFlota', ['listaTransportesStore']),
    ...mapState('KPIStatusTransporte', ['kpi']),
    ...mapState('Cliente', ['clientes']),
    ...mapState('Permisos', ['permisos']),
    ...mapState('Siniestros', ['estados']),
    ...mapState('AndinaSupermercado', ['estadosAndinaSupermercado']),
    ...mapState('Acarreo', ['estadosAcarreo']),
    ...mapState('Administrador', ['administradores'])
  }
}
